import { render, staticRenderFns } from "./NotFound404.vue?vue&type=template&id=258e318a&scoped=true"
import script from "./NotFound404.vue?vue&type=script&lang=js"
export * from "./NotFound404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258e318a",
  null
  
)

export default component.exports